module.exports = __webpack_public_path__ + "assets/img/1_1795_big.91e06196.jpg";